var _path, _rect, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4, _path5, _ellipse4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyTask = function SvgEmptyTask(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 149,
    viewBox: "0 0 113 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4223 104.118C99.029 102.31 108.419 88.4976 106.396 73.2662C104.373 58.0348 91.7024 47.1525 78.0957 48.9599C64.489 50.7673 55.0987 64.5799 57.1219 79.8113C59.1451 95.0426 71.8156 105.925 85.4223 104.118ZM83.7618 91.6148C90.8697 90.6707 95.7353 83.1554 94.6293 74.8289C93.5233 66.5024 86.8645 60.5178 79.7566 61.462C72.6486 62.4061 67.783 69.9215 68.889 78.2479C69.995 86.5744 76.6538 92.559 83.7618 91.6148Z",
    fill: "url(#paint0_linear_664_61243)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.31885,
    y: 44.1777,
    width: 75.6,
    height: 78.975,
    rx: 7.425,
    transform: "rotate(-7.5663 1.31885 44.1777)",
    fill: "url(#paint1_linear_664_61243)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.4334,
    cy: 111.8,
    rx: 37.8,
    ry: 17.2125,
    transform: "rotate(-7.5663 48.4334 111.8)",
    fill: "url(#paint2_linear_664_61243)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4564,
    cy: 44.2194,
    rx: 37.8,
    ry: 14.5125,
    transform: "rotate(-7.5663 39.4564 44.2194)",
    fill: "url(#paint3_linear_664_61243)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4564,
    cy: 44.2194,
    rx: 37.8,
    ry: 14.5125,
    transform: "rotate(-7.5663 39.4564 44.2194)",
    fill: "url(#paint4_linear_664_61243)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2553 53.3097C16.4443 48.7117 27.0179 44.8489 39.323 43.2145C51.7227 41.5674 63.0159 42.5636 70.183 45.4369C63.9701 49.857 53.3828 53.6036 41.0801 55.2378C28.678 56.8852 17.3983 56.0052 10.2553 53.3097Z",
    fill: "#7AC3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16101 26.1433C-3.01899 37.7533 5.48601 49.2058 10.886 53.4808C13.2485 54.1557 14.936 54.1558 17.636 54.1558C20.336 54.1558 27.4235 46.3933 24.0485 42.3433C20.6735 38.2933 18.6485 42.0058 14.936 42.6808C11.2235 43.3558 13.2485 37.2808 16.961 31.5433C20.6735 25.8058 11.561 18.7183 6.16101 26.1433Z",
    fill: "url(#paint5_linear_664_61243)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8855 0C0.566962 0 -0.963805 11.5816 0.616575 18.4324C1.42915 21.9549 4.04256 21.4171 5.36826 18.054C5.74426 17.1001 6.5456 15.7885 8.19803 13.8375C16.298 7.7625 16.6355 0 9.8855 0Z",
    fill: "url(#paint6_linear_664_61243)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.474 12.1122C20.5116 9.64314 17.0873 11.6497 14.9218 14.2329C12.612 16.9882 14.5372 17.8047 18.0788 17.185C23.4505 17.461 26.2285 14.4081 23.474 12.1122Z",
    fill: "url(#paint7_linear_664_61243)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.44,
    rx: 42.8625,
    ry: 4.3875,
    transform: "matrix(-1 0 0 1 50.3623 144.112)",
    fill: "url(#paint8_linear_664_61243)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_61243",
    x1: 78.9073,
    y1: 56.4082,
    x2: 87.0025,
    y2: 103.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_664_61243",
    x1: 4.01885,
    y1: 89.7402,
    x2: 79.8545,
    y2: 86.4088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_664_61243",
    x1: 13.3334,
    y1: 114.448,
    x2: 88.5514,
    y2: 106.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_664_61243",
    x1: 50.4814,
    y1: 18.7126,
    x2: 38.7491,
    y2: 63.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_664_61243",
    x1: 39.7939,
    y1: 51.9819,
    x2: 38.6979,
    y2: 34.5432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACD9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_664_61243",
    x1: 17.9823,
    y1: 32.4469,
    x2: -13.24,
    y2: 31.2079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_664_61243",
    x1: 10.2,
    y1: 7.0875,
    x2: -9.71249,
    y2: 6.4125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_664_61243",
    x1: 21.1916,
    y1: 15.1115,
    x2: 13.2954,
    y2: 8.06317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_664_61243",
    x1: 95.4665,
    y1: 0.585,
    x2: 88.4639,
    y2: 31.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyTask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-task.91de85b1e079fc13564b96470f6ffb23.svg";